import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getAccountGroup,
  getParticularPage,
  getNext,
  getPrevious,
  createAccountGroup,
  updateAccountGroup,
  handleSearch,
  getAccountGroupById,
  getAllAccountGroup,
} from "./thunk";

const initialState = {
  allAccountGroups: [],
  accountGroups: [],
  edit: false,
  accountGroup: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingAccountGroup: false,
  loadingNext: false,
  loadingAllGroups: false,
  showCreateModal: false,
};

export const accountGroupSlice = createSlice({
  name: "accountGroup",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    clearAllAccountGroup: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingAccountGroup = false;
      state.accountGroup = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAccountGroupById.pending, (state) => {
      state.loading = true;
      state.edit = true;
    });
    builder.addCase(getAccountGroupById.fulfilled, (state, action) => {
      state.loading = false;
      state.accountGroup = action.payload.data;
    });
    builder.addCase(getAccountGroupById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createAccountGroup.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createAccountGroup.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createAccountGroup.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateAccountGroup.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateAccountGroup.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateAccountGroup.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getAllAccountGroup.pending, (state) => {
      state.loadingAllGroups = true;
    });
    builder.addCase(getAllAccountGroup.fulfilled, (state, action) => {
      state.loadingAllGroups = false;
      state.allAccountGroups = action.payload.data;
    });
    builder.addCase(getAllAccountGroup.rejected, (state) => {
      state.loadingAllGroups = false;
    });
    builder.addMatcher(
      isAnyOf(
        getAccountGroup.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingAccountGroup = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAccountGroup.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingAccountGroup = false;
        state.accountGroups = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAccountGroup.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingAccountGroup = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, accountGroupEditSuccess, clearAllAccountGroup } =
  accountGroupSlice.actions;

export default accountGroupSlice.reducer;
